// Actions
export const SET_OUTPUTS = 'SET_OUTPUTS';
export const UPDATE_OUTPUT = 'UPDATE_OUTPUT';
